import styled, { css } from 'styled-components';
import { APPS_PHONE_MEDIA } from '../apps.constants';
import { WINDOW_RADIUS, windowSurfaceOf } from './AppWindow.constants';

// The rim is masked to a 1px ring so it paints only the border, over whatever the window holds.
export const Window = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  border-radius: ${WINDOW_RADIUS};
  ${({ theme }) => css`
    background: ${windowSurfaceOf(theme)};
    box-shadow:
      ${theme.elevation?.level2 ?? '0 0 0 transparent'},
      0 0 48px -12px color-mix(in srgb, ${theme.colors.primary} 30%, transparent);

    &::before {
      content: '';
      position: absolute;
      inset: 0;
      z-index: 2;
      padding: 1px;
      border-radius: inherit;
      background: conic-gradient(
        from 180deg at 50% 50%,
        ${theme.colors.tertiary},
        ${theme.colors.primary} 22%,
        ${theme.colors.secondary} 50%,
        ${theme.colors.primary} 78%,
        ${theme.colors.tertiary}
      );
      opacity: 0.35;
      pointer-events: none;
      mask:
        linear-gradient(#000 0 0) content-box exclude,
        linear-gradient(#000 0 0);
    }
  `}

  &:fullscreen {
    border-radius: 0;
  }

  ${APPS_PHONE_MEDIA} {
    border-radius: 12px;
  }
`;

export const WindowBar = styled.header`
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-height: 56px;
  padding: 8px 12px;
  box-sizing: border-box;
  border-bottom: 1px solid ${({ theme }) => theme.colors.outlineVariant};
`;
